import React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Typography, Theme } from "@material-ui/core";
import { LayoutConst } from "../../constants";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pageTitle: {
      backgroundColor: theme.extra.pageHeader.background,
      padding: "0.125rem 0.5rem 0.125rem 0.5rem",
      height: LayoutConst.pageHead.height,
    },
  })
);

interface Props {
  title: string;
}

/** ページヘッダDIV */
export function PageHeadDiv(props: Props) {
  const classes = useStyles();
  const { title } = props;
  return (
    <div className={classes.pageTitle}>
      <Typography variant="subtitle2" component="h3">
        {title}
      </Typography>
    </div>
  );
}
